import { string } from "prop-types"
import { useLayoutTheme } from "source/shared/contexts/ThemeContext"
import color from "color"
import { getComputedStylePropertyValue } from "source/shared/getComputedStylePropertyValue"

const SRCSET_WIDTHS = [56, 96, 128, 200, 256, 400, 600, 900]

Avatar.propTypes = {
  url: string.isRequired,
  alt: string,
  className: string,
}

const getHexColorFromStyleProperty = (propertyName) =>
  getComputedStylePropertyValue(propertyName)
    ? color(getComputedStylePropertyValue(propertyName)).hex().replace("#", "")
    : ""

export function useAvatarColors({ isHeader = false } = {}) {
  useLayoutTheme()

  const foregroundColor = getHexColorFromStyleProperty(
    isHeader ? "--d-fill-color-neutral-070" : "--d-fill-color-neutral-030",
  )

  const backgroundColor = getHexColorFromStyleProperty(
    isHeader ? "--d-fill-color-neutral-020" : "--d-fill-color-neutral-070",
  )

  return {
    foregroundColor,
    backgroundColor,
  }
}

function stripParams(url) {
  return url.split("?")[0]
}

export function Avatar({ url, alt = "avatar", className = "" }) {
  const { foregroundColor, backgroundColor } = useAvatarColors()
  const baseUrl = stripParams(url).replace("http:", "https:")
  const colorParams = `background_color=${backgroundColor}&color=${foregroundColor}`

  const srcSet = SRCSET_WIDTHS.map(
    (w) => `${baseUrl}?g=${w}x${w}%23&${colorParams} ${w}w`,
  ).join(", ")

  const fallbackSrc = `${baseUrl}?g=200x200%23&${colorParams}`

  return (
    <img
      src={fallbackSrc}
      srcSet={srcSet}
      sizes="auto"
      alt={alt}
      loading="lazy"
      className={className}
      style={{
        borderRadius: "50%",
        aspectRatio: "1 / 1",
        objectFit: "cover",
      }}
    />
  )
}
